const apiUrl = process.env.REACT_APP_API_URL;

export const addUser = async(email, userName, roleId) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/users/addUser`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            email, 
            userName, 
            roleId
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       const jsonResponse =  await response.json();
       return jsonResponse.result;
    } catch (error) {
        return false;
    }
}